import { graphql } from "@/shared/api";
import mkClient from "@/shared/api/graphqlClient";

const getProfileQ = graphql(/* GraphQL */ `
  query GetProfile($userId: UUID!) {
    profileCollection(filter: { id: { eq: $userId } }) {
      edges {
        node {
          id
          username
        }
      }
    }
  }
`);

export default async function getProfile(userId: string) {
  const client = await mkClient();

  try {
    const result = await client.request({
      document: getProfileQ,
      variables: { userId }
    });
    return result.profileCollection?.edges?.[0]?.node ?? null;
  } catch {
    return null;
  }
}
